export const ROUTER_ROOT = '/';
export const ROUTER_HOME = '/home';
export const ROUTER_SCREENING = '/screening';
export const ROUTER_WATCHLIST = '/watchlist';
export const ROUTER_WATCHLIST_DETAIL = `${ROUTER_WATCHLIST}/details`;

export const ROUTER_COMPANY_DETAIL_PREFIX = '/company';
export const ROUTER_COMPANY_DETAIL = `${ROUTER_COMPANY_DETAIL_PREFIX}/:id`;

//ESG风险管理
export const ROUTER_QUESTIONAIRE = '/esg-risk-dd/questionaire-list';
export const ROUTER_QUESTIONAIRE_DETAIL = '/esg-risk-dd/questionaire/detail/:id';

// 绿色金融业务统计
export const ROUTER_STATISTICS_SCREEN = '/statistics/screen';
export const ROUTER_STATISTICS_REPORT = '/statistics/report';

// 碳核算管理
export const ROUTER_CARBON_ACCOUNT_MANAGEMENT = '/carbon-account-management';
export const ROUTER_CARBON_ACCOUNT_MANAGEMENT_INSTITUTION = `${ROUTER_CARBON_ACCOUNT_MANAGEMENT}/institution`;
export const ROUTER_CARBON_ACCOUNT_MANAGEMENT_PROJECT_LOAN = `${ROUTER_CARBON_ACCOUNT_MANAGEMENT}/project-loan`;
export const ROUTER_CARBON_ACCOUNT_MANAGEMENT_NON_PROJECT_LOAN = `${ROUTER_CARBON_ACCOUNT_MANAGEMENT}/non-project-loan`;
export const ROUTER_CARBON_ACCOUNT_MANAGEMENT_EMISSION_SOURCE = `${ROUTER_CARBON_ACCOUNT_MANAGEMENT}/emission-source`;
export const ROUTER_CARBON_ACCOUNT_MANAGEMENT_TRADING = `${ROUTER_CARBON_ACCOUNT_MANAGEMENT}/trading`;
export const ROUTER_CARBON_ACCOUNT_MANAGEMENT_CONSUMPTION = `${ROUTER_CARBON_ACCOUNT_MANAGEMENT}/consumption`;

// 碳排放核算填报
export const ROUTER_CARBON_EMISSION_ACCOUNT = '/carbon-emission-account';
export const ROUTER_CARBON_EMISSION_ACCOUNT_INSTITUTION = `${ROUTER_CARBON_EMISSION_ACCOUNT}/institution`;
export const ROUTER_CARBON_EMISSION_ACCOUNT_PROJECT_LOAN = `${ROUTER_CARBON_EMISSION_ACCOUNT}/project-loan`;
export const ROUTER_CARBON_EMISSION_ACCOUNT_NON_PROJECT_LOAN = `${ROUTER_CARBON_EMISSION_ACCOUNT}/non-project-loan`;
export const ROUTER_CARBON_EMISSION_ACCOUNT_TRADING = `${ROUTER_CARBON_EMISSION_ACCOUNT}/trading`;
export const ROUTER_CARBON_EMISSION_ACCOUNT_CONSUMPTION = `${ROUTER_CARBON_EMISSION_ACCOUNT}/consumption`;

// 碳减排/环境效益核算填报
export const ROUTER_CARBON_REDUCTION_ACCOUNT = '/carbon-reduction-account';
export const ROUTER_CARBON_REDUCTION_ACCOUNT_PROJECT_LOAN = `${ROUTER_CARBON_REDUCTION_ACCOUNT}/project-loan`;
export const ROUTER_CARBON_REDUCTION_ACCOUNT_NON_PROJECT_LOAN = `${ROUTER_CARBON_REDUCTION_ACCOUNT}/non-project-loan`;
export const ROUTER_CARBON_REDUCTION_ACCOUNT_TRADING = `${ROUTER_CARBON_REDUCTION_ACCOUNT}/trading`;
export const ROUTER_CARBON_REDUCTION_ACCOUNT_CONSUMPTION = `${ROUTER_CARBON_REDUCTION_ACCOUNT}/consumption`;

// 机构碳核算详情
export const ROUTER_CARBON_ACCOUNT_DETAIL_INSTITUTION = `/carbon-account-detail-institution`;

// 项目库
export const ROUTER_PROJECT_LIBRARY = '/project-library';

export const ROUTER_PROJECT_LIBRARY_DETAIL = `${ROUTER_PROJECT_LIBRARY}/:id`;

// 对公信贷业务管理
export const ROUTER_CORPORATE = '/corporate';

// 创建项目
export const ROUTER_CREATE_PROJECT = '/create-corporate-project';
export const ROUTER_IDENTIFY_PROJECT_COMPANY = '/project-details';
export const ROUTER_IDENTIFY_PROJECT_COMPANY_DETAIL = `${ROUTER_IDENTIFY_PROJECT_COMPANY}/:id`;

// 风险调查
export const ROUTER_RISK_SURVEY = '/risk-survey';
export const ROUTER_RISK_SURVEY_SUCCESS = '/risk-survey/success';
export const ROUTER_ENV_INFORMATION_DISCLOSURE = `/env-information-disclosure`;
export const ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL = `${ROUTER_ENV_INFORMATION_DISCLOSURE}/detail`;
export const ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL_ID = `${ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL}/:id`;

// 授信客户列表
export const ROUTER_COMPANY_LIST = '/company-list';
export const ROUTER_COMPANYS_DETAIL = `${ROUTER_COMPANY_LIST}/detail`;
export const ROUTER_COMPANY_DETAIL_PDF = `${ROUTER_COMPANY_DETAIL}/pdf`;
export const ROUTER_COMPANY_SUCCESS = '/company-successfully';

// risk tracking
export const ROUTER_RISK_TRACKING = '/risk-tracking';
export const ROUTER_RISK_TRACKING_LIST = `${ROUTER_RISK_TRACKING}/list`;
export const ROUTER_RISK_TRACKING_LIST_COMPANY = `${ROUTER_RISK_TRACKING_LIST}/company`;
export const ROUTER_RISK_TRACKING_LIST_STANDARD = `${ROUTER_RISK_TRACKING_LIST}/standard`;
export const ROUTER_RISK_TRACKING_DETAIL_COMPANY_PREFIX = `${ROUTER_RISK_TRACKING}/detail/company`;
export const ROUTER_RISK_TRACKING_DETAIL = `${ROUTER_RISK_TRACKING_DETAIL_COMPANY_PREFIX}/:id`;

// data collection platform
export const ROUTER_DATA_COLLECTION_PLATFORM = '/data-collection-platform';
export const ROUTER_DATA_COLLECTION_PLATFORM_TYPE = `${ROUTER_DATA_COLLECTION_PLATFORM}/:type`;

export const ROUTER_DATA_COLLECTION_PLATFORM_LISTED_COMPANY = `${ROUTER_DATA_COLLECTION_PLATFORM}/listed/company`;
export const ROUTER_DATA_COLLECTION_PLATFORM_LISTED_COMPANY_DETAIL = `${ROUTER_DATA_COLLECTION_PLATFORM_LISTED_COMPANY}/:id`;
export const ROUTER_DATA_COLLECTION_PLATFORM_QUESTIONNAIRE = `${ROUTER_DATA_COLLECTION_PLATFORM}/detail/:cid`;


export const ROUTE_ERROR_403 = '/403';

export const ROUTER_CARBON_CORPORATE = '/carbon-corporate'; // 对公详情页权限判断使用
export const ROUTER_CHANGEPASSWORD = '/change-password'; // 修改密码
